const editorScript = require('./editor-script');

module.exports = {
  ...editorScript,
};
